import { useQuery } from '@tanstack/react-query';
import { getSettings } from '../api/fetchers/settingsFetcher';


export const useGetSettings = (settings = []) => {
    return useQuery({
        queryKey: ['navbar-settings'],
        queryFn: () => getSettings(settings),
        staleTime: 1000 * 60 * 5,
    });
};
